import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, doc, text } from "./kit";
import type { LabelTemplate } from "./types";

// Bold typographic: the name IS the label, set big and condensed on black.
function wine(): CanvasData {
  return doc("wine", INK.black, [
    text({ text: "YOUR\nNAME", font: "bebas-neue", size: 24, color: INK["warm-white"], baseline: 44, x: 6, width: 78, align: "left", lineHeight: 0.9 }),
    text({ text: "SOH GD WINES · 2026", font: "montserrat", size: 1.8, color: INK.gold, baseline: 88, x: 6, width: 78, align: "left", tracking: 0.25 }),
  ]);
}

export const boldType: LabelTemplate = {
  key: "bold-type",
  name: "Bold type",
  occasion: "modern",
  style: "Bold typographic",
  description: "Your name, big and condensed, on black.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
